import { useRouteError, useNavigate } from 'react-router';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button.tsx';

import { extractErrorData } from '@/utils/errors';

export default function RouteErrorPage() {
	const error = useRouteError() as Error;

	const errorData = extractErrorData(error);

	const navigate = useNavigate();

	return (
		<div className="flex dark:bg-slate-900 h-full flex-col items-center justify-center">
			<Card>
				<div className="min-w-[17em]">
					<CardHeader>
						<CardTitle>Oops!</CardTitle>
						<CardDescription>{errorData.errorMessage}</CardDescription>
					</CardHeader>
					<CardContent>
						<p className="p-2 mt-2 bg-red-400 text-white text-sm">
							<span>Error code: {errorData.errorCode}</span>
						</p>
						<div className="mt-2">
							<Button variant="link" className="p-0" onClick={() => navigate(-1)}>
								Back
							</Button>
						</div>
					</CardContent>
				</div>
			</Card>
		</div>
	);
}
